import React from "react";
import PropTypes from "prop-types";
import { Typography, useTheme, Box, Skeleton } from "@mui/material";
import { Item } from "./Item";

const CardDashboardText = ({ title, content, isLoading = false }) => {
  const theme = useTheme();
  
  return (
    <Item
      sx={{
        display: "grid",
        gridTemplateRows: "auto 1fr",
        position: "relative",
        padding: theme.spacing(2),
        height: "140px",
        minHeight: "140px",
      }}
    >
      {/* Title in the top left */}
      <Box sx={{ gridRow: "1 / 2", alignSelf: "start", justifySelf: "start" }}>
        <Typography
          variant="h5"
          sx={{ fontWeight: "bold", color: theme.palette.primary.text2 }}
        >
          {title}
        </Typography>
      </Box>

      {/* Centered text content */}
      <Box
        sx={{
          gridRow: "2 / 3",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        {isLoading ? (
          <Box sx={{ width: "100%", textAlign: "center" }}>
            <Skeleton
              variant="text"
              width="80%"
              height={60}
              animation="wave"
              sx={{
                backgroundColor: theme.palette.background.default,
                margin: "0 auto",
              }}
            />
          </Box>
        ) : (
          <Typography
            variant="h2"
            align="center"
            sx={{ fontWeight: "bold", color: theme.palette.primary.main }}
          >
            {content}
          </Typography>
        )}
      </Box>
    </Item>
  );
};

CardDashboardText.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
};

export default CardDashboardText;
